export const GET_SCORE = 'GET_SCORE';
export const GET_LESSON = 'GET_LESSON';
export const COMMENT_LIST = 'COMMENT_LIST';
export const LESSON_EXIST = 'LESSON_EXIST';
export const FILE_PREVIEW = 'FILE_PREVIEW';
export const FILE_NO_EXIST = 'FILE_NO_EXIST';
export const GET_REWORD_LESSON = 'GET_REWORD_LESSON';
export const GET_UPLOAD_LESSON = 'GET_UPLOAD_LESSON';
export const GET_PREVIEW_LESSON = 'GET_PREVIEW_LESSON';
